import React, { useEffect } from "react";
import { AlertTriangle, XCircle, ShieldCheck, Phone } from "lucide-react";

const NEVER = [
  "Ask you to pay via WhatsApp, SMS, DM, or informal broker",
  "Use gift cards, crypto USDT wallets, or 'agent-only' bank accounts",
  "Request your visa, residence card, or immigration papers abroad",
  "Ask for your bank login, OTP, or PIN — ever",
  "Contact you from any email that is NOT Sebata@pulalove.com",
  "Sell your data or share your details outside your Personal Log",
];

const OFFICIAL = [
  "Payments only via the official Pay page on the Mavula site",
  "The one official contact email: Sebata@pulalove.com",
  "One official WhatsApp: +44 7424 311882",
  "Every transaction has a receipt with a MVL-… reference visible in your Personal Log",
];

export default function ScamWarningPage() {
  useEffect(() => { document.title = "Scam Warning · MAVULA Investment"; }, []);
  return (
    <main data-testid="scam-warning-page">
      <section className="py-16 md:py-24 relative overflow-hidden" style={{ background: "linear-gradient(180deg, #4b0d0d, #7a1a1a)" }}>
        <div className="absolute inset-0 opacity-25" style={{ background: "radial-gradient(600px 300px at 20% 0%, #d4af37, transparent 60%)" }}/>
        <div className="max-w-4xl mx-auto px-4 md:px-8 relative text-white">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-[11px] uppercase tracking-[0.24em]"
               style={{ background: "rgba(255,255,255,0.15)", color: "#F8D57E" }}>
            <AlertTriangle size={14}/> Read this before you pay anyone
          </div>
          <h1 className="font-display text-4xl md:text-6xl mt-5 leading-[1]">
            Scam Warning. <span className="font-accent italic" style={{ color: "#F8D57E" }}>Protect yourself.</span>
          </h1>
          <p className="mt-5 max-w-2xl text-white/85 text-[15.5px]">
            Property scams are common — especially for diaspora buyers. MAVULA has 4 hard rules and 4 official channels.
            If anyone contacting you doesn't match this page, they are <b>not</b> MAVULA.
          </p>
        </div>
      </section>

      <section className="py-14 md:py-20 border-b mv-hairline">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <div className="mv-eyebrow"><span style={{ color: "#B33A3A" }}>§ MAVULA Will Never</span></div>
          <h2 className="font-display text-3xl md:text-4xl mv-green-text mt-3">Never. <span className="font-accent italic" style={{ color: "var(--mv-gold)" }}>Not once.</span></h2>
          <ul className="mt-8 space-y-3">
            {NEVER.map((r) => (
              <li key={r} className="mv-card p-5 flex gap-4 items-start" style={{ background: "linear-gradient(180deg, #fff, rgba(233,60,60,0.04))" }} data-testid={`scam-never-${r.slice(0,8)}`}>
                <XCircle size={22} className="shrink-0" style={{ color: "#B33A3A" }}/>
                <div className="font-display text-[15px] mv-green-text leading-snug">{r}</div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="py-14 md:py-20 border-b mv-hairline">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <div className="mv-eyebrow"><span style={{ color: "var(--mv-gold)" }}>§ Official Channels Only</span></div>
          <h2 className="font-display text-3xl md:text-4xl mv-green-text mt-3">Trust these four. <span className="font-accent italic" style={{ color: "var(--mv-gold)" }}>Nothing else.</span></h2>
          <ul className="mt-8 space-y-3">
            {OFFICIAL.map((r) => (
              <li key={r} className="mv-card p-5 flex gap-4 items-start" style={{ background: "linear-gradient(180deg, #fff, rgba(37,211,102,0.06))" }} data-testid={`scam-official-${r.slice(0,8)}`}>
                <ShieldCheck size={22} className="shrink-0" style={{ color: "#0A7A2C" }}/>
                <div className="font-display text-[15px] mv-green-text leading-snug">{r}</div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="py-14 md:py-20 mv-green-bg text-white">
        <div className="max-w-4xl mx-auto px-4 md:px-8 flex flex-col md:flex-row items-start gap-6">
          <Phone size={40} style={{ color: "#F8D57E" }}/>
          <div>
            <div className="text-[11px] tracking-[0.24em] uppercase" style={{ color: "#F8D57E" }}>If in doubt</div>
            <h2 className="font-display text-3xl md:text-4xl mt-2">Stop. Call us first.</h2>
            <p className="mt-3 max-w-xl text-white/85 text-[15px]">
              If <b>anyone</b> calls, DMs, or emails you claiming to be MAVULA and doesn't match the four channels above —
              stop the conversation and message our official WhatsApp. We will confirm in writing within 24 hours.
            </p>
            <a href="https://wa.me/447424311882?text=Is%20this%20a%20real%20MAVULA%20contact%3F" target="_blank" rel="noopener"
               className="btn-gold mt-6 inline-flex" data-testid="scam-wa-cta">
              <Phone size={16}/> Verify on WhatsApp
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
